module.exports = __webpack_public_path__ + "7706ed86ed6c0d3becac49ac57738d39.svg";